import { canShowSketchPropertySection, registerPropertyManagerSection } from '@/core';
import { SketchPolygonCommand } from '@puppycad/cad-core';
import PolygonPropertySection from '@/components/editor/property-manager/polygon/PolygonPropertySection.vue';

registerPropertyManagerSection({
  id: SketchPolygonCommand.Polygon,
  title: '多边形',
  order: 14,
  component: PolygonPropertySection,
  actions: {
    confirm: true,
  },
  isApplicable: (context) => canShowSketchPropertySection(context, context.polygonPropertyVisible === true),
});
